const menu = [
    {
        id: 1,
        title: 'buttermilk pancakes',
        category: 'breakfast',
        price: 15.99,
        img: 'https://media.gettyimages.com/photos/occasions-pancakes-with-fresh-strawberries-picture-id840139596?k=6&m=840139596&s=612x612&w=0&h=g6nmnyv5mim7ENubYmEVYY_hDETPSwxgCSbKUELZL_w=',
        desc: `I'm baby woke mlkshk wolf bitters live-edge blue bottle, hammock freegan copper mug whatever cold-pressed `,
    },
    {
        id: 2,
        title: 'diner double',
        category: 'lunch',
        price: 13.99,
        img: 'https://media.gettyimages.com/photos/authentic-indian-food-picture-id639389404?k=6&m=639389404&s=612x612&w=0&h=Zg3cBTKgClDVzlFU8fjKApe2Ms74kWGk3aE7PR2gXoM=',
        desc: `vaporware iPhone mumblecore selvage raw denim slow-carb leggings gochujang helvetica man braid jianbing. Marfa thundercats `,
    },
    {
        id: 3,
        title: 'godzilla milkshake',
        category: 'shakes',
        price: 6.99,
        img: 'https://c4.wallpaperflare.com/wallpaper/833/344/836/dessert-figs-cream-wallpaper-preview.jpg',
        desc: `ombucha chillwave fanny pack 3 wolf moon street art photo booth before they sold out organic viral.`,
    },
    {
        id: 4,
        title: 'country delight',
        category: 'breakfast',
        price: 20.99,
        img: 'https://images.unsplash.com/photo-1617692855027-33b14f061079?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzB8fHNwaWN5JTIwZm9vZHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        desc: `Shabby chic keffiyeh neutra snackwave pork belly shoreditch. Prism austin mlkshk truffaut, `,
    },
    {
        id: 5,
        title: 'egg attack',
        category: 'lunch',
        price: 22.99,
        img: 'https://images.unsplash.com/photo-1580442151529-343f2f6e0e27?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHNwaWN5JTIwZWdnJTIwZm9vZHN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        desc: `franzen vegan pabst bicycle rights kickstarter pinterest meditation farm-to-table 90's pop-up `,
    },
    {
        id: 6,
        title: 'oreo dream',
        category: 'shakes',
        price: 18.99,
        img: 'https://images.unsplash.com/photo-1541658016709-82535e94bc69?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fG9yZXklMjBtaWxrc2hha2V8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        desc: `Portland chicharrones ethical edison bulb, palo santo craft beer chia heirloom iPhone everyday`,
    },
    {
        id: 7,
        title: 'bacon overflow',
        category: 'breakfast',
        price: 8.99,
        img: 'https://images.unsplash.com/photo-1620374229300-59b3e0770a49?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8YmFjb24lMjBzcGljeSUyMGZvb2RzfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
    },
    {
        id: 8,
        title: 'american classic',
        category: 'lunch',
        price: 12.99,
        img: 'https://images.unsplash.com/photo-1555658094-ca794654362c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8YW1lcmljYW4lMjBjbGFzc2ljJTIwZm9vZHN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
    },
    {
        id: 9,
        title: 'quarantine buddy',
        category: 'shakes',
        price: 16.99,
        img: 'https://images.unsplash.com/photo-1543573852-1a71a6ce19bc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NjR8fG1pbGtzaGFrZXN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60',
        desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
    },
];
export default menu;